import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {queryClientList, getMediaWallList} from '@apis'
import {Chart} from '@antv/g2'

const NodeMonitoring = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId} = userInfo

    // 获取节点信息
    async function queryMediaWallList() {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await getMediaWallList(params)
      if (res && res.data) {
        getClientList(res.data)
      }
    }

    // 获取节点监控信息
    async function getClientList(value) {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await queryClientList(params)
      if (res && res.data) {
        let nodeClientList = []
        value.map(item => {
          res.data.data.map(e => {
            if(item.code == e.appCode) {
              nodeClientList.push(e)
            }
          })
        })
        const total = nodeClientList.length
        const offlineList = nodeClientList.filter(item => new Date(item.dateTime).valueOf()+5*60*1000<new Date().valueOf()).length
        const rateData = [
          {item: '运行总数', 个数: total-offlineList},
          {item: '停运总数', 个数: 0, percent: 0},
          {item: '离线总数', 个数: offlineList}
        ]
        creatChat(rateData)
      }
    }

    useEffect(() => {
      queryMediaWallList()
    }, [])

    function creatChat(data) {
      const chart = new Chart({
        container: 'monitor-container',
        autoFit: true,
        height: 200,
      });

      chart.data(data);
      chart.scale('个数', {
        nice: true,
      });

      chart.tooltip({
        showMarkers: false
      });
      chart.interaction('active-region');

      chart.interval()
        .position('item*个数')
        .color('rgb(16, 250, 233)');

      chart.render();
    }

    return (
      <div className='ck-node-monitor'>
        <div className='title'>节点监测情况</div>
        <div className='monitor-item'>
          <div className='monitor-index'>
            <div id='monitor-container' className='monitor-container'>
            </div>
          </div>
        </div>
      </div>
    )
  })
)

export default NodeMonitoring
